/** Inventory is stored per flight; a journey is limited by its lowest known flight capacity. */
export function getSeatsLeftFromJourney(journey?: App.JourneyV2): number | undefined {
  if (!journey?.flightGroup?.flights) {
    return undefined
  }

  const seatsLeftValues = journey.flightGroup.flights
    .map(flight => flight.seatsLeft)
    .filter((seats): seats is number => typeof seats === 'number' && seats >= 0)

  if (seatsLeftValues.length === 0) {
    return undefined
  }

  return Math.min(...seatsLeftValues)
}

/** Unknown inventory on one leg retains the known leg's capacity, including zero. */
export function getRoundTripSeatsLeft(departingJourney?: App.JourneyV2, returningJourney?: App.JourneyV2): number | undefined {
  const departingSeats = getSeatsLeftFromJourney(departingJourney)
  const returningSeats = getSeatsLeftFromJourney(returningJourney)
  if (typeof departingSeats === 'number' && typeof returningSeats === 'number') return Math.min(departingSeats, returningSeats)
  if (typeof departingSeats === 'number') return departingSeats
  if (typeof returningSeats === 'number') return returningSeats
  return undefined
}

/** Seat availability is only relevant after the guest has selected a complete stay. */
export function hasInsufficientCharterSeats(checkInDate: string | undefined, checkOutDate: string | undefined, duration: number | undefined, seatsLeft: number | undefined, seatEligiblePassengers: number): boolean {
  return !!checkInDate && (!!checkOutDate || !!duration) && typeof seatsLeft === 'number' && seatsLeft < seatEligiblePassengers
}
